export default "__VITE_ASSET__B5mkbf3x__"